"use client";

import { PricingTab } from "./pricing-tab";
import { useTranslations } from "next-intl";
import type { Plan as PlanType } from "./types";

export function PricingTable({
  isAnnual,
  setIsAnnual,
  plans,
}: {
  isAnnual: boolean;
  setIsAnnual: (isAnnual: boolean) => void;
  plans: PlanType[];
}) {

  const t = useTranslations("pricing");


  return (
    <section>
      {/* <div className="flex justify-center max-w-[14rem] m-auto mb-8 lg:mb-16">
        <div className="relative flex w-full p-1 bg-contrast rounded-full border-border border">
          <span
            className="absolute inset-0 m-1 pointer-events-none"
            aria-hidden="true"
          >
            <span
              className={`absolute inset-0 w-1/2 bg-primary rounded-full shadow-sm shadow-primary/40 transform transition-transform duration-150 ease-in-out ${
                isAnnual ? "translate-x-0" : "translate-x-full"
              }`}
            ></span>
          </span>
          <button
            className={`relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 ease-in-out ${
              isAnnual ? "text-primary-foreground" : "text-slate-500"
            }`}
            onClick={() => setIsAnnual(true)}
            aria-pressed={isAnnual}
          >
            Yearly{" "}
            <span
              className={`${isAnnual ? "text-slate-200" : "text-slate-400"}`}
            >
              -20%
            </span>
          </button>
          <button
            className={`relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 ease-in-out ${
              !isAnnual ? "text-primary-foreground" : "text-slate-500"
            }`}
            onClick={() => setIsAnnual(false)}
            aria-pressed={isAnnual}
          >
            Monthly
          </button>
        </div>
      </div> */}

      <div className="max-w-sm mx-auto grid gap-6 lg:grid-cols-2 items-start lg:max-w-none">
       
       {
        plans.map((plan, index) => {

          const features = Object.values(plan.features)
          .flatMap((items) =>
            Object.entries(items).map(([key, value]) => {
              if (value === true) {
                return t(`features.${key}`);
              } else if (typeof value === "number" || typeof value === "string") {
                return `${value} ${t(`features.${key}`)}`;
              } else {
                return null;
              }
            })
          )
          .filter((feature) => feature !== null);


          return (
            <PricingTab
              yearly={isAnnual}
              planName={plan.name}
              popular={plan.popular}
              price={plan.price}
              ctaLink={plan.ctaLink}
              cta={plan.cta}
              planDescription={plan.description}
              key={index}
              features={
                features
              }
            />
          )})
        }
        
       
      </div>
    </section>
  );
}
